import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { MwCorePreferenceService } from '@core/auth/services/preference.service';

@Injectable()
export class MwPagesDataResolveService implements Resolve<any> {
  constructor(private preferenceService: MwCorePreferenceService) {}
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.preferenceService.preference$.pipe(take(1));
  }
}
